import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import { DropTarget } from "react-dnd";
import { ItemTypes } from "../../constants/elements";

class DropTargetable extends PureComponent {
  render() {
    const { connectDropTarget, isOverCurrent } = this.props;
    return connectDropTarget(
      <div
        style={{
          border: isOverCurrent && !this.props.canvas ? "1px solid blue" : "none",
          width: "100%",
          height: "100%"
        }}>
        {this.props.children}
      </div>
    );
  }
}

const boxTarget = {
  drop(props, monitor, block) {
    if (!monitor.didDrop()) {
      const mouse = monitor.getClientOffset();
      const { top, left } = ReactDOM.findDOMNode(block).getBoundingClientRect();
      const itemType = monitor.getItemType();
      const item = monitor.getItem();

      //consider moving or duplicating if id exists (probably mean it has been dropped fron the Layers)
      if (!item.id) {
        block.props.onDropBlockInside(
          block.props.id,
          itemType,
          item,
          mouse.y - top - 20,
          mouse.x - left - 20
        );
      }
    }
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true })
  };
}

export default DropTarget(Object.values(ItemTypes), boxTarget, collect)(DropTargetable);



// WEBPACK FOOTER //
// ./src/canvas/enhancers/dropTargetable.js